import * as React from 'react';
import {withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import { connect } from 'react-redux'; // Connecting to Redux
import { Dispatch } from 'redux';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import SchoolDTO from 'src/models/school/SchoolDTO';
import SchoolApiController from 'src/api/SchoolApiController';
import Button from 'antd/lib/button/button';
import { Tooltip, message } from 'antd';
import UserAction from "src/redux/UserActions";


interface SchoolsProps extends PageProps<{}>, LocalizeContextProps {
    emulateSchool: (schoolId: number) => Promise<boolean>;
}

interface SchoolsState {
    isLoading: boolean;
    tableRecords: SchoolDTO[];
}

class Schools extends React.Component<SchoolsProps, SchoolsState> {
    constructor(props: SchoolsProps) {
        super(props);
        bindAllOfThis(this, Schools.prototype);

        this.state = {
            tableRecords: [],
            isLoading: true
        };
    }

    private emulateSchool(schoolId: number) {
        return this.props.emulateSchool(schoolId).then(result => {
            if (!result) {
                message.error(this.props.translate("admin.common.messageEmulateError"));
                return;
            }
            // New user info should exist at this point, but props might not have updated yet. Push to home screen
            this.props.history.push(Routes.BASE_ROUTE); // Let login redirect them
        });
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<SchoolDTO>) => void) {
        this.setState({ isLoading: true });

        return SchoolApiController.getSchoolTableData(requestState)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    isLoading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<SchoolDTO>[] {
        let editLink = (text, record: SchoolDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_SCHOOL, record.schoolId);

        return [
            DataTable.StandardColumns.Text('admin.schools.columnHeader1', 'schoolName'),
            {
                columnProps: {
                    key: 'emulate',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={this.props.translate('admin.common.emulateColumnHeader')} arrowPointAtCenter>
                                <Button shape="circle" icon="user" onClick={() => this.emulateSchool(record.schoolId)} />
                            </Tooltip>
                        );
                    }
                }
            },
            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit')
        ];
    }

    render() {
        return (
            <div>
                <h2>{this.props.translate('admin.schools.tableHeader')}</h2>

                <DataTable
                    serverSide={true}
                    tableProps={{ rowKey: 'schoolId', loading: this.state.isLoading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('admin.schools.addButton', () => this.props.history.push(Routes.getRoute(Routes.ADMIN_ADD_EDIT_SCHOOL, 0))),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return ({
        emulateSchool: (schoolId: number) => UserAction.EmulateUser(dispatch, "school", schoolId),
    });
}

export default connect(null, mapDispatchToProps)(withLocalize(Schools));



// WEBPACK FOOTER //
// ./src/pages/admin/Schools.tsx